var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "reviews-prs-plate flex-shrink-0",
      class: { "w-100": _setup.isMobile },
    },
    [
      _c(
        _setup.CorePRG,
        {
          class: { "w-100": _setup.isMobile },
          attrs: { url: _vm.url, "button-attrs": _setup.buttonAttrs },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "reviews-prs-plate__content d-flex align-center rounded px-3 py-2",
              class: { "w-100": _setup.isMobile },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "reviews-prs-plate__icon d-flex align-center justify-center flex-shrink-0 rounded-lg bg-lpu-branding-color-primary",
                },
                [
                  _c("span", {
                    staticClass:
                      "ui-icon-piggy-bank ui-icon-fz-big bg-gray-0--text",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-body-1 font-weight-medium ml-4 mr-2",
                  class: [
                    _setup.ff_lpu_branding_page_v5
                      ? "text-lpu-branding-color-text"
                      : "text-lpu-branding-color-primary",
                    { "text-no-wrap": !_setup.isMobile },
                  ],
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.tStatic("Дарим скидку")) +
                      " 300 ₽ " +
                      _vm._s(_setup.tStatic("за честный отзыв")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", {
                staticClass:
                  "ui-icon-arrow-right ui-icon-fz-big ml-auto flex-shrink-0",
                class: _setup.ff_lpu_branding_page_v5
                  ? "text-lpu-branding-color-text"
                  : "text-lpu-branding-color-primary",
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }